<template>
  <div class="invoice">
    <Title text="发票信息" />
    <!-- 发票类型 -->
    <div class="invoice-type" v-if="this.$route.params.type">
      <p class="title">发票类型</p>
      <div class="type-list">
        <span @click="chooseInvoice('noInvoice')">不需要发票</span>
        <span @click="chooseInvoice('invoice')">增值税专用发票</span>
      </div>
      <p class="prompt">发票将在订单收货完成且增票资质认证完成后，3个工作日内寄出</p>
    </div>
    <!-- 发票抬头 -->
    <div class="invoice-content form-wrap">
      <p class="title">发票抬头</p>
      <van-cell-group>
        <van-field
          v-model.trim="invoiceUp.invoiceTitle"
          required
          clearable
          :readonly="disabled"
          label="单位名称"
          placeholder="请根据营业执照填写"
        />
        <van-field
          v-model.trim="invoiceUp.tin"
          type="number"
          label="纳税人识别号"
          placeholder="请按照税务登记证填写"
          required
          clearable
          :readonly="disabled"
        />
        <van-field
          v-model="invoiceUp.companyAddress"
          required
          clearable
          label="注册地址"
          placeholder="请根据营业执照填写"
          :readonly="disabled"
        />
        <van-field
          v-model="invoiceUp.companyTelephone"
          type="number"
          label="注册电话"
          maxlength="11"
          placeholder="请按照税务登记证填写"
          required
          clearable
          :readonly="disabled"
        />
        <van-field
          v-model="invoiceUp.depositBankName"
          required
          clearable
          label="开户银行"
          placeholder="请根据开户许可证填写"
          :readonly="disabled"
        />
        <van-field
          v-model="invoiceUp.depositBankAccount"
          label="银行账号"
          placeholder="请根据开户许可证填写"
          clearable
          required
          :readonly="disabled"
        />
      </van-cell-group>
    </div>
    <!-- 确定 -->
    <button class="comfire" v-if="btnShow" @click="saveInvoice">保存信息</button>
    <button class="comfire edit-btn" v-if="!btnShow" @click="editClick">编辑信息</button>
  </div>
</template>

<script>
import Title from "../components/Title";
import { MemInvoice, SaveInvoice } from "../request/api";
// import { required } from "vuelidate/lib/validators";
export default {
  name: "invoice",
  data() {
    return {
      showArea: false,
      disabled: true,
      btnShow: true,
      validateFlag: false,
      invoiceUp: {
        invoiceTitle: "",
        tin: "",
        companyAddress: "",
        companyTelephone: "",
        depositBankName: "",
        depositBankAccount: "",
        pdfAddress: "file"
      }
    };
  },
  components: {
    Title
  },
  created() {
    this.getInvoice();
  },
  methods: {
    //获取发票信息
    getInvoice() {
      MemInvoice({}).then(res => {
        if (res.data) {
          this.invoiceUp = res.data;
          this.invoiceUp.pdfAddress = "file";
          this.disabled = true;
          this.btnShow = false;
        } else {
          this.disabled = false;
          this.btnShow = true;
        }
      });
    },
    editClick(invoiceUp) {
      this.disabled = false;
      this.btnShow = true;
    },
    //验证表单
    validations() {
      let invoiceTitle = this.invoiceUp.invoiceTitle.length;
      let tin = this.invoiceUp.tin.length;
      let companyAddress = this.invoiceUp.companyAddress.length;
      let companyTelephone = this.invoiceUp.companyTelephone.length;
      let depositBankName = this.invoiceUp.depositBankName.length;
      let depositBankAccount = this.invoiceUp.depositBankAccount.length;
      if (invoiceTitle < 1) {
        this.$toast("营业执照不能为空");
      } else if (tin < 1) {
        this.$toast("纳税人识别号不能为空");
      } else if (companyAddress < 1) {
        this.$toast("注册地址不能为空");
      } else if (companyTelephone < 1) {
        this.$toast("注册电话不能为空");
      } else if (depositBankName < 1) {
        this.$toast("开户银行不能为空");
      } else if (depositBankAccount < 1) {
        this.$toast("银行账号不能为空");
      } else {
        this.validateFlag = true;
      }
    },
    //保存
    saveInvoice() {
      this.validations();
      if (this.validateFlag) {
        SaveInvoice(this.invoiceUp).then(res => {
          if (res.status == 200) {
            this.$toast.success({
              message: "发票保存成功",
              duration: 700
            });
            this.disabled = true;
            this.btnShow = false;
          } else {
            this.$toast.fail({
              message: res.msg,
              duration: 700
            });
          }
        });
      }
    },
    //选择发票
    chooseInvoice(type) {
      if (this.$route.params.type) {
        switch (type) {
          case "noInvoice":
            this.$router.push({
              name: "payment",
            });
            sessionStorage.setItem('invoice','不需要发票')
            break;
          case "invoice":
            if (this.invoiceUp != null) {
              this.$router.push({
                name: "payment",
              });
              sessionStorage.setItem('invoice',this.invoiceUp.invoiceTitle)
            }
            break;
        }
      } else {
        return;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.invoice {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
// 发票类型
.invoice-type {
  background: #fff;
  padding: 30px;
  margin-bottom: 20px;
  .title {
    color: #666;
    font-size: 28px;
  }
  .type-list {
    display: flex;
    margin: 30px 0;
    span {
      padding: 20px;
      border: 1px solid #e5e5e5;
      font-size: 26px;
      border-radius: 10px;
    }
    span:last-child {
      border-color: #ff9900;
      margin-left: 30px;
    }
  }
  .prompt {
    font-size: 24px;
    color: #ccc;
  }
}
// 发票抬头
.invoice-content {
  padding: 30px;
  background: #fff;
  .title {
    color: #666;
    font-size: 28px;
    margin-bottom: 30px;
  }
}
.comfire {
  width: 690px;
  height: 90px;
  color: #fff;
  font-size: 32px;
  margin: 30px;
  border: none;
  background: #ff9900;
  border-radius: 10px;
  margin-top: 80px;
}
.edit-btn {
  border: 1px solid #ff9900;
  background: #fff;
  color: #ff9900;
}
/* 表单验证样式 */
.form-group__message {
  display: none;
  font-size: 12px;
  color: #cc3333;
}
.form-group--error > .form-group__message {
  display: block;
  color: #cc3333;
  font-size: 26px;
  padding: 20px 0 0 30px;
}
</style>